var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"outils_item",attrs:{"href":_vm.url,"target":"_blank"}},[_c('h2',{staticClass:"outils_item_title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }